/*************************************************/
/* Partials                                      */
/*************************************************/
import Rotator from "./partials/clientiRotator.js";

/*************************************************/
/* Init                                          */
/*************************************************/
const rotatorElementsSelector = '.rotate-image__images';
const poiTriggerElementSelector = '.rotate-image__list-item';
const poiTriggerElementParentSelector = '.rotate-image__inner-list';

let rotators = [];
const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    //Magic
    const rotatorElements = document.querySelectorAll(rotatorElementsSelector);
    if (rotatorElements) {
        rotatorElements.forEach(element => {
            const rotator = {
                'Id': element.id,
                'Rotator': Rotator(element)
                    .interval(10)
                    .reverse(true)
                    .on("dragEnd", (n) => {
                        const vm = rotator;
                        let reverse = true;
                        const goal = n;
                        const poisElements = [...element.closest(".rotate-image__inner ").querySelectorAll(".rotate-image__list-item")];
                        const pois = poisElements.map((x) => x.dataset.poiValue);
                        if (vm.dragDirection == "left") {
                            reverse = false;
                        }
                        
                        var closest = pois.reduce(function (prev, curr) {
                            return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
                        });
                        vm.currentPoi = pois.find((x) => x == closest);

                        vm.Rotator.reverse(reverse);
                        vm.Rotator.play(closest);
                        vm.Rotator.reverse(true);
                    })
            };
            rotators.push(rotator);
        });
    }

    const poiTriggerElements = document.querySelectorAll(poiTriggerElementSelector);
    if (poiTriggerElements) {
        poiTriggerElements.forEach(trigger => {
            trigger.addEventListener('click', e => {
                poiTriggerElements.forEach(poi => {
                    poi.classList.remove("active-poi");
                })
                const rotatorId = trigger.closest(poiTriggerElementParentSelector).dataset.rotatorId;
                const poiValue = trigger.dataset.poiValue;
                const rotator = rotators.find(x => x.Id == rotatorId).Rotator;

                trigger.classList.add("active-poi");

                rotator.reverse(false);
                rotator.play(poiValue);
                rotator.reverse(true);

                return false;
            });
        });
    }

});